module.exports = __webpack_public_path__ + "img/reactions.f7debf4f.svg";